import { extend } from 'vee-validate';

extend('dedicated_trial_code', {
  validate: (value) => {
    return {
      required: true,
      // Least 8 characters, include alphabets and numeric
      valid: /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,}$/.test(value),
    };
  },
  computesRequired: true,
});
